module.exports = __webpack_public_path__ + "img/Yacky.571c7c9f.webp";